module.exports = __webpack_public_path__ + "img/varilux-physio.28517083.svg";